export const TRANSLATIONS = ['en-GB', 'fr-FR'] as const;

export type Translation = typeof TRANSLATIONS[number];

export const getUserLang = () => {
  const userLang = (localStorage.getItem('lang') || navigator.language) as Translation;

  return TRANSLATIONS.includes(userLang) ? userLang : 'en-GB';
}
